import { Injectable, inject } from '@angular/core';
import { AppStoreQuery } from '@core/state/app-state.query';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ReadOnlyUserService {
  private appStoreQuery = inject(AppStoreQuery);

  /**
   * Check if the current user is read-only (observable)
   */
  public isReadOnlyUser(): Observable<boolean> {
    return this.appStoreQuery.selectUser().pipe(map((user) => user?.isReadonly ?? false));
  }

  /**
   * Check if the current user is read-only (synchronous)
   * Use this for immediate checks in components
   */
  public getIsReadOnlyUser(): boolean {
    const state = this.appStoreQuery.getValue();
    const isReadonlyUser = state?.user?.isReadonly ?? false;
    const isReadonlyView = state?.viewType === 'readonly';
    return isReadonlyUser || isReadonlyView;
  }

  /**
   * Check if user profile indicates read-only (from userProfile state)
   */
  public isReadOnlyFromProfile(): Observable<boolean> {
    return this.appStoreQuery.selectUserProfile().pipe(map((profile) => profile?.isReadonly ?? false));
  }
}
